import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert, Confirm } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능:직원계정 추가
 * 세부설명:
*/

export class EmpList extends Component {
    static displayName = EmpList.name;

    constructor(props) {
        super(props);
        this.state = {
            EmpList: [],
            RoleList: [],
            Sub_Uid:"",
            Sub_Nm: "",
            Login_Id: "",
            Password: "",
            Content: "",
            RegisterSuccess: false,    //등록 완료
            Permission: [],
            Role_CdInfo: { Role_Cd: "" },
            CRUD:"I"
             
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSave_Click = this.handleSave_Click.bind(this);
        this.handleMove_Click = this.handleMove_Click.bind(this);
        this.handleStop_Click = this.handleStop_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        this.RoleCodeDataCall();
        this.CallEmpList();
    }
    async handleChange(event) {
        let target = event.target;
        let tagId = target.id;
        let value = target.value.trim();        
        if (target.type === 'checkbox') {
            if (target.checked) {
                let Permission = Big3Common.Util.Cloen(this.state.Role_CdInfo);
                Permission.Role_Cd = tagId;
                this.state.Permission.push(Permission);
                this.forceUpdate();
            }
            else {
                Big3Common.Util.RemoveModelListRow(this.state.Permission, "Role_Cd", tagId);
                this.forceUpdate();
            }
        }
        else {
            this.setState({ [tagId]: value });
        }
        return false;
    }
    //아이디 조회
    async GetSubLoginId() {
        try {
            //신규추가할 생성되지 않은 아이디           
            let Data = await Big3Common.Get('api/MyPage/Employee/GetSubLoginId');
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let LoginId = Data.objectData;
                this.InitState();
                this.setState({ Login_Id: LoginId });
            }
            else {
                console.log("아이디 조회에 실패했습니다.");
            }
        }
        catch (e) {
            console.log("GetSubLoginId: ", e)
        }
        return false;
    }
    async handleSave_Click() {
        
        if (this.state.Sub_Nm.trim().length === 0) {
            this.setState({ Content: "직원명을 입력하여 주세요." });
        }
        else if (this.state.CRUD === "I" && this.state.Password.trim().length === 0)
        {
            this.setState({ Content: "비밀번호를 입력하여 주세요." });
             
        }
        else if (this.state.CRUD === "I" && !Big3Common.Util.isPassWordValid(this.state.Password))
        {
            this.setState({ Content: "영문 대, 소문자, 특수기호를 포함 8~20자리를 입력해주세요" });
        }
        else if (this.state.CRUD === "U" && this.state.Password.trim().length > 0 && !Big3Common.Util.isPassWordValid(this.state.Password))
        {
            this.setState({ Content: "영문 대, 소문자, 특수기호를 포함 8~20자리를 입력해주세요" });
        }
        else {
            let Model = {
                Submember: {
                    Sub_Uid: this.state.Sub_Uid,
                    Sub_Nm: this.state.Sub_Nm,
                    Password: this.state.Password
                },
                SubmemberRole: this.state.Permission
            }
            let postUrl = this.state.CRUD === "I" ? "api/MyPage/Employee/RegisterSubmember" : "api/MyPage/Employee/ModifySubmember";

            let Data = await Big3Common.Post(postUrl, Model, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ Content: Data.message, RegisterSuccess: true });
            }
            else {
                this.setState({ Content: Data.message });
            }
        }
        Big3Common.ModalAlert(bootstrap, 'MessageAlert');
        return false;
    }
    //사용중지
    async handleStop_Click() {

        let Data = await Big3Common.Get(`api/MyPage/Employee/ModifySubmemberUseYn/${this.state.Sub_Uid}`);
        if (Data.codeName === Big3Common.ResultCode.Success) {
            this.setState({ Content: Data.message, RegisterSuccess: true });
        }
        else {
            this.setState({ Content: Data.message });
        }
        Big3Common.ModalAlert(bootstrap, 'MessageAlert');
        return false;
    }
    InitState() {
        this.setState({
            Sub_Uid:"",
            Sub_Nm: "",
            Login_Id: "",
            Password: "",
            Content: "",
            RegisterSuccess: false,
            Permission: [],
            CRUD: "I"
        });
    }
    //저장 후 초기화
    handleMove_Click() {
        if (this.state.RegisterSuccess) {
            Big3Common.ModalClose(bootstrap, 'EmpAddModal');
            this.CallEmpList();
        }
    }
    async RoleCodeDataCall() {
        try {
            //권한관리 코드 018
            const MstCd = "018";
            let Data = await Big3Common.Get(`api/Common/BaseCode/GetCommonCode/${MstCd}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let RoleList = JSON.parse(Data.dataTable);
                if (RoleList.length > 0) {
                    this.setState({ RoleList: RoleList }) 
                }
            }
            else {
                console.log("등록된 코드가 없습니다.");
            }
        }
        catch (e) {
            console.log("RoleCodeDataCall: ", e)
        }
        return false;
    }
    //직원계정 리스트
    async CallEmpList() {
        try {
           
            let Data = await Big3Common.Get('api/MyPage/Employee/GetSubmemberList');
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let EmpList = JSON.parse(Data.dataTable);
                if (EmpList.length > 0) {
                    this.InitState();
                    this.setState({ EmpList: EmpList });
                }
            }
            else {
                console.log("등록된 정보가 없습니다.");
            }
        }
        catch (e) {
            console.log("CallEmpList: ", e)
        }
        return false;
    }
    //직원상세
    async CallSubMemberRoleList(Sub_Uid) {
        try {
            
            let Data = await Big3Common.Get(`api/MyPage/Employee/GetSubmemberRoleList/${Sub_Uid}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let SubmemberRole = JSON.parse(Data.dataTable);
                if (SubmemberRole.length > 0) {
                    let Member = this.state.EmpList.filter(list => list.sub_uid === Sub_Uid);
                    let Permission = [];
                    SubmemberRole.map(list => {
                        let PermissionInfo = Big3Common.Util.Cloen(this.state.Role_CdInfo);
                        PermissionInfo.Role_Cd = list.role_cd;
                        Permission.push(PermissionInfo);
                        return false;
                    })
                    this.setState({
                        Sub_Uid: Sub_Uid,
                        Sub_Nm: Member[0].sub_nm,
                        Login_Id: Member[0].login_id,
                        Permission: Permission,
                        CRUD:"U"
                    });
                }
            }
            else {
                console.log("등록된 정보가 없습니다.");
            }
        }
        catch (e) {
            console.log("CallSubMemberRoleList: ", e)
        }
        return false;
    }
    Buttonrender() {
        if (this.state.CRUD === "I") {
            return (
                <div className="modal-footer notice_modal_footer">
                    <button type="button" className="m_btn" onClick={this.handleSave_Click}>직원계정 요청</button>
                </div>
                );
        }
        else {
            return (
                <div className="modal-footer notice_modal_footer">
                    <button type="button" className="m_btn m_btn2" onClick={() => {
                        Big3Common.ModalAlert(bootstrap, 'ConfirmBox');
                    }}>사용중지</button>
                    <button type="button" className="m_btn m_btn2" onClick={this.handleSave_Click}>직원정보변경</button>
                </div>
                );
        }
    }
    //직원계정 요청
    EmpAddrender() {
        let RoleList = this.state.RoleList;
        let Permission = this.state.Permission;
        let Button = this.Buttonrender();
        return (
            <div className="modal fade" id="EmpAddModal" aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content EmpDtl_modal">
                        <div className="modal-header EmpDtl_modal_header">
                            <div className="modal-title">직원계정 요청</div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="employee_info_box bn">
                                <div className="input_line">
                                    <label>직원명</label>
                                    <input type="text"
                                        className="form-control"
                                        id="Sub_Nm"
                                        maxLength="20"
                                        value={this.state.Sub_Nm}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                <div className="input_line">
                                    <label>아이디</label>
                                    <input type="text"
                                        className="form-control"
                                        id="Sub_Uid"
                                        maxLength="20"
                                        value={this.state.Login_Id}
                                        readOnly
                                    />
                                </div>
                                <div className="input_line last">
                                    <label>비밀번호</label>
                                    <input type="password"
                                        className="form-control"
                                        id="Password"
                                        maxLength="20"
                                        value={this.state.Password}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                            <div className="emplyee_check_box">
                                <div className="emplyee_check_txt">해당 직원이 접근할 수 있는 권한을 설정해 주세요.</div>
                                {
                                    RoleList.map(list => 
                                        <div className="alarm_check" key={list.dtl_cd}>
                                            {
                                                list.dtl_cd === "OR" || list.dtl_cd === "GO" ?
                                                    <input className="form-check-input" type="checkbox" checked={true} readOnly /> :
                                                    <input className="form-check-input"
                                                        id={list.dtl_cd}
                                                        value={list.dtl_cd}
                                                        checked={Permission.filter(lic => lic.Role_Cd === list.dtl_cd).length > 0 ? true : false}
                                                        onChange={this.handleChange}
                                                        type="checkbox"
                                                    />
                                            } 
                                            <label className="form-check-label">
                                                {list.dtl_nm}
                                            </label>
                                        </div>
                                )}                                 
                            </div>
                        </div>
                        {Button }
                    </div>
                </div>
            </div>
        )
    }
    render() {
        let EmpAddModal = this.EmpAddrender();
        let EmpList = this.state.EmpList;
        return (
            <div>
                <div className="p_b_margin container_box d_padding">
                    {
                        EmpList.map((list, idx) =>
                            <div className="employee_box" key={list.sub_uid}>
                                <div className="label">직원{idx+1 }</div>
                                <div className="employee_name_box">
                                    <div className="employee_name">{list.sub_nm}</div>
                                    <div className="status">{list.appr_status === "WA" ? "(승인요청)" : list.appr_status === "CA" ? "(사용중지)" : ""}</div>
                                    <div className="plus_button" onClick={() => {
                                        Big3Common.ModalAlert(bootstrap, 'EmpAddModal');
                                        this.CallSubMemberRoleList(list.sub_uid);
                                    }}></div>
                                </div>
                            </div>
                    )}
                </div>
                <div className="catagory_button_box">
                    <button type="button" className="btn_v btn_v1" onClick={() => {
                        Big3Common.ModalAlert(bootstrap, 'EmpAddModal');
                       
                        this.GetSubLoginId();

                    }}>직원추가하기</button>
                </div>
                {EmpAddModal}
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title="직원계정관리"
                    AlertClick={this.handleMove_Click}
                />
                <Confirm
                    id="ConfirmBox"
                    title="직원계정관리"
                    content="계정 사용을 중지하면 더 이상 사용할 수 없습니다.<br/>계속 진행하시겠습니까?"
                    ConfirmClick={() => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);
                        this.handleStop_Click();
                    }}
                />
            </div>
        );
    }
}
